import { useTheme } from "../../theme/useTheme"
import { Contacts } from "../ui/Contacts"
import { Section } from "./Section"
import { Box, Typography } from "@mui/material"

interface FooterProps {
    currentPage?: number
    totalPages?: number
}

export const Footer = ({ currentPage = 1, totalPages = 1 }: FooterProps) => {
    const { layout, themeSettings } = useTheme()

    return (
        <Section marginTop={layout.verticalSpacing * 2} marginBottom={0}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                <Box sx={{ width: 32, minWidth: 32 }}></Box>

                <Contacts variant="footer" />
                <Box sx={{ width: 32, minWidth: 32, textAlign: "right" }}>
                    {/* page number = index ornament → solid faint is allowed
                        here (BRAND.md); alpha tint is not */}
                    <Typography variant="body2" sx={{ color: themeSettings.faintColor }}>
                        {currentPage} of {totalPages}
                    </Typography>
                </Box>
            </Box>
        </Section>
    )
}
